import { version } from "../package.json";

export const appVersion = process.env.REACT_APP_VERSION || version;

// Per-build identity is separate from the API/Sentry release version.
export const appBuildId = process.env.REACT_APP_BUILD_ID;
